import React from 'react'
import './Footer.css'

const Footer=()=> {
  return (
    <footer>
        <p>Copyright &#169; 2022 Arunchandra Boini. All Rights Reserved</p> 
    </footer>
  )
}
export default Footer;